import React, { Component } from "react"
import SystemCardBasic from "components/system/layout/SystemCardBasic"

export class SystemPageBasic extends Component {
    render() { return (<SystemCardBasic />) }
}
